import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import axios from 'axios';
import { AiTwotoneMail } from 'react-icons/ai';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { GrFacebookOption, GrLinkedinOption, GrTwitter } from 'react-icons/gr';
import { HiLocationMarker } from 'react-icons/hi';
import { SiYoutube } from 'react-icons/si';
import TextField from '@mui/material/TextField';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import StyledButton from '../../layout_components/StyledButton';
import countries from './countriesList';
import { validateEmail } from '../../../services/helpers/helpers';
import CustomModal from '../../layout_components/CustomModal';
import { useMediaQuery } from '@mui/material';
import { FlagIcon } from "react-flag-kit";



const ContactForm = ({ inquiryType }) => {
    const isMobile = useMediaQuery('(max-width: 640px)');

    const mails = {
        tech: 'inquiry@thetalentgames.com',
        candidateSupport: 'inquiry@thetalentgames.com',
        sales: 'sales@thetalentgames.com'
    };

    const regexes = {
        titleFieldsRegex: /^[a-zA-Z ]+$/,
        emailRegex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        pakPhoneRegex: /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm
    };

    const validations = {
        cannotEmpty: {
            value: true,
            message: 'Field cannot be Empty'
        },
        textOnly: {
            value: regexes.titleFieldsRegex,
            message: 'value should be in plain text'
        },
        emailPattern: {
            value: regexes.emailRegex,
            message: 'Incorrect Email Format'
        },
        numberFormat: (e) => matchIsValidTel(e) || 'Incorrect Number Format'
    };

    const { cannotEmpty, textOnly, emailPattern, numberFormat } = validations;

    const { handleSubmit, formState: { errors }, control, reset } = useForm();
    const [form, setForm] = useState({});
    const [loader, setLoader] = useState(false)
    const [modal, setmodal] = useState(false)

    const closeModal = () => {
        setmodal(false)
    }

    const handleFormSubmit = (data) => {
        setLoader(true)
        const {
            fullName,
            companyName,
            companyEmail,
            jobTitle,
            contactNumber,
            countryOfResidence,
            message
        } = data;

        setForm({
            inquiryType,
            formDetails: {
                fullName,
                companyName,
                companyEmail,
                jobTitle,
                contactNumber: contactNumber.split(' ').join(''),
                countryOfResidence,
                message
            }
        });

        const sdata = {
            name: fullName,
            company: companyName,
            email: companyEmail,
            job: jobTitle,
            contact: contactNumber.split(' ').join(''),
            country: countryOfResidence,
            message: message,
            type: inquiryType
        };

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://backendpaygo.thetalent.games/auth/email/sendsaas',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: sdata
        };

        axios(config)
            .then(function (response) {
                setLoader(false)
                setmodal(true)
                console.log(JSON.stringify(response.data));
                reset();
            })
            .catch(function (error) {
                console.log(error);
            });
    };


    useEffect(() => {
        console.log('FormDetails', form);
    }, [form]);

    return (
        <div className="form ">
            <div className="formWrapper lg:flex lg:justify-between 2xl:px-[3rem]">
                {/* <div className="left lg:w-[24rem] xl:w-[28rem] 2xl:w-[35rem]"> */}
                <div className="left lg:w-[50%] lg:mr-10">
                    <form className="p-1 flex flex-col" onSubmit={handleSubmit(handleFormSubmit)}>
                        <div className="title 2xl:text-[24px] 2xl:leading-[30px] font-bold sm:font-normal">
                            <h4 className='text-[#3B4345]'>Leave us a message</h4>
                        </div>


                        {/* Full Name */}
                        <Controller
                            name='fullName'
                            control={control}
                            defaultValue=''
                            rules={{ required: cannotEmpty, pattern: textOnly }}
                            render={({ field }) => (
                                <>
                                    <div htmlFor="fullName" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>Full Name <span className='text-lg'>*</span></div>
                                    <TextField
                                        {...field}
                                        className='!mt-5'
                                        // label={`${!isMobile ? "Full Name *" : ""}`}
                                        label={!isMobile ? <p>Full Name <span className='text-lg'>*</span></p> : ""}

                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                        error={!!errors.fullName}
                                        helperText={errors.fullName && errors.fullName.message}
                                        placeholder="Your Full Name Here"
                                        disabled={loader}

                                    />
                                </>

                            )}

                        />

                        {/* Company Name */}
                        <Controller
                            name='companyName'
                            control={control}
                            defaultValue=''
                            rules={{ required: cannotEmpty, pattern: textOnly }}

                            render={({ field }) => (
                                <>
                                    <div htmlFor="companyName" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>Company Name <span className='text-lg'>*</span></div>
                                    <TextField
                                        {...field}
                                        className="!mt-5"
                                        // label={`${!isMobile ? "Company Name *" : ""}`}
                                        label={!isMobile ? <p>Company Name <span className='text-lg'>*</span></p> : ""}
                                        
                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                        error={!!errors.companyName}
                                        helperText={errors.companyName && errors.companyName.message}
                                        placeholder="Your Company Name Here"
                                        disabled={loader}


                                    />
                                </>

                            )}

                        />

                        {/* Company Email */}
                        <Controller
                            name='companyEmail'
                            control={control}
                            defaultValue=''
                            rules={{ required: cannotEmpty, pattern: emailPattern, validate: validateEmail }}
                            render={({ field }) => (
                                <>


                                    <div htmlFor="companyEmail" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>{inquiryType === "candidateSupport" ? <div>Institute/Company Email <span className='text-lg'>*</span></div> :<div>Work Email <span className='text-lg'>*</span></div>}</div>

                                    <TextField
                                        {...field}
                                        className='!mt-5'
                                        // label={`${!isMobile ? inquiryType === 'candidateSupport' ? "Institute/Company Email *" : "Work Email *" : ""}`}
                                        label={!isMobile ? inquiryType === 'candidateSupport' ? <p>Institute/Company Email <span className='text-lg'>*</span></p> : <p>Work Email <span className='text-lg'>*</span></p>: ""}
                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                        error={!!errors.companyEmail}
                                        helperText={errors.companyEmail && errors.companyEmail.message}
                                        placeholder="Your Email Address Here"
                                        disabled={loader}

                                    />
                                </>

                            )}

                        />

                        {/* Job Title */}
                        <Controller
                            name='jobTitle'
                            control={control}
                            defaultValue=''
                            rules={{ required: cannotEmpty, pattern: textOnly }}
                            render={({ field }) => (
                                <>


                                    <div htmlFor="jobTitle" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>Job Title <span className='text-lg'>*</span></div>

                                    <TextField
                                        className='!mt-5'
                                        {...field}
                                        // label={`${!isMobile ? "Job Title *" : ""}`}
                                        label={!isMobile ? <p>Job Title <span className='text-lg'>*</span></p> : ""}

                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                        error={!!errors.jobTitle}
                                        helperText={errors.jobTitle && errors.jobTitle.message}
                                        placeholder="Your Job Title Here"
                                        disabled={loader}


                                    />
                                </>

                            )}

                        />

                        {/* Contact Number */}
                        <Controller
                            name='contactNumber'
                            control={control}
                            defaultValue=''
                            rules={{ required: cannotEmpty, validate: numberFormat }}
                            render={({ field }) => (
                                <>


                                    <div htmlFor="contactNumber" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>Contact Number <span className='text-lg'>*</span></div>


                                    <MuiTelInput
                                        {...field}
                                        error={!!errors.contactNumber}
                                        helperText={errors.contactNumber && errors.contactNumber.message}
                                        id="outlined-basic"
                                        // label={`${!isMobile ? "Contact Number *" : ""}`}
                                        label={!isMobile ? <p>Contact Number <span className='text-lg'>*</span></p> : ""}
                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                        className="w-[100%] !mt-5"
                                        placeholder="e.g. +923131256789"
                                        defaultCountry='CA'
                                        disableFormatting={true}
                                        disabled={loader}

                                    />
                                </>
                            )}
                        />


                        {/* Country of Residence */}

                        <Controller
                            name='countryOfResidence'
                            control={control}
                            defaultValue={''}
                            rules={{ required: cannotEmpty }}
                            render={({ field }) => (
                                <>

                                    <div htmlFor="countryOfResidence" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>Country of Residence <span className='text-lg'>*</span></div>

                                    <FormControl fullWidth
                                        className='!mt-5'
                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                    >
                                        {
                                            !isMobile &&
                                            <InputLabel className={`${!!errors.countryOfResidence && '!text-[#d32f2f]'} !mt-2`} id="demo-simple-select-helper-label"><p>Country of Residence <span className='text-lg'>*</span></p></InputLabel>
                                        }
                                        <Select
                                            {...field}
                                            className="!mt-2"
                                            labelId="demo-simple-select-helper-label"
                                            id="demo-simple-select-helper"
                                            error={!!errors.countryOfResidence}
                                            label="Country of Residence * 1"

                                            disabled={loader}


                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {
                                                countries.map((country, index) => (
                                                    <MenuItem key={country.value} value={country.label}>
                                                        <div className="label flex items-center">

                                                            <FlagIcon code={country.value} size={20} className="ml-2" /><span className='ml-6'>{country.label}</span>
                                                        </div>
                                                    </MenuItem>
                                                ))
                                            }

                                        </Select>
                                        {
                                            !!errors.countryOfResidence &&
                                            <FormHelperText className='!text-[#d32f2f]'>{errors.countryOfResidence && errors.countryOfResidence.message}</FormHelperText>
                                        }
                                    </FormControl>
                                </>
                            )}
                        />

                        {/* Message */}
                        <Controller
                            name='message'
                            control={control}
                            rules={{ required: cannotEmpty }}
                            defaultValue=''
                            render={({ field }) => (
                                <>

                                    <div htmlFor="message" className='sm:hidden text-[#242426] !mt-5 font-[450] text-[14px] leading-[20px]'>Your Message <span className='text-lg'>*</span></div>


                                    <TextField
                                        {...field}
                                        className='!mt-5'
                                        label={!isMobile ? <p>Your Message <span className='text-lg'>*</span></p> : ""}
                                        // label={`${!isMobile ? "Your Message *" : ""}`}
                                        variant={`${isMobile ? 'standard' : 'outlined'}`}
                                        multiline={true}
                                        rows={5}
                                        error={!!errors.message}
                                        helperText={errors.message && errors.message.message}
                                        placeholder="Your Message Here"
                                        disabled={loader}
                                        sx={{
                                            fontSize: "1rem !important"
                                        }}

                                    />
                                </>

                            )}

                        />

                        <div className="submitBtn flex justify-center sm:justify-start">

                            <StyledButton
                                btnDisabled={loader}
                                btnText={loader ? "Please Wait" : "Submit"}
                                customStyle={`mt-5 !tracking-[1px] 2xl:!w-[10rem] xl:!w-[9rem] lg:!w-[8rem] md:!w-[7rem] sm:!w-[7rem] !bg-[#FFD700] !font-semibold !h-[3rem] !font-400 !text-[#333333] hover:!bg-[#333333] hover:text-white w-full lg:w-[10rem] 2xl:!h-[3.5rem] xl:!text-[18px]  xl:!font-700 xl:!leading-[20px]  ${loader && '!bg-gray-300 hover:!bg-gray-300 !text-white'}`}
                            />
                        </div>
                        <CustomModal isOpen={modal} handleCloseModal={closeModal} allData={{ heading: "khurram", desc: "Thank you for submitting! Someone from our team will reach out to you soon." }} />
                    </form>
                </div>
                {/* <div className="right mt-20 sm:mt-0  lg:block lg:w-[20rem] xl:w-[27rem] flex flex-col justify-center 2xl:w-[27rem]"> */}
                <div className="right mt-20 sm:mt-10  lg:block lg:w-[50%]">
                    <div className="contactDetails">
                        {/* <div className="phone flex items-center">
                            <BsFillTelephoneFill className='text-[20px] 2xl:text-[29px]' />
                            <p className="ml-2  2xl:text-[24px]">+1 123 123 123</p>
                        </div> */}
                        <div className="email flex items-center mt-2 2xl:mt-3">
                            <AiTwotoneMail className='text-[20px] 2xl:text-[29px]' />
                            <p className="ml-2 2xl:text-[24px]"><a href={`mailto:${mails[inquiryType]}`}>{mails[inquiryType]}</a></p>
                        </div>
                        <div className="socials flex mt-2 lg:mt-5 2xl:mt-5 items-center">
                            <a href="https://www.youtube.com/channel/UCTjzlMHDYCqi2XubmFvb0Jw" target="_blank" rel="noreferrer">
                                <SiYoutube className='text-[1.5rem] 2xl:text-[1.7rem] text-[red] mr-2' />
                            </a>
                            <a href="https://www.facebook.com/games.talent/" target="_blank" rel="noreferrer">
                                <GrFacebookOption className='text-[1.3rem] 2xl:text-[1.5rem] text-blue-600 mr-2' />
                            </a>
                            <a href="https://twitter.com/GamesTalent" target="_blank" rel="noreferrer">
                                <GrTwitter className='text-[1.3rem] 2xl:text-[1.5rem] text-[#17A3F8] mr-2' />
                            </a>
                            <a href="https://linkedin.com/company/thetalentgames" target="_blank" rel="noreferrer">
                                <GrLinkedinOption className='text-[1.3rem] 2xl:text-[1.5rem] text-blue-600 mr-3' />
                            </a>

                        </div>

                        {/* map start */}

                        <div className="map mt-5">
                            <div className="mapouter">
                                <div className="gmap_canvas">
                                    <iframe
                                        title='iframe'
                                        className="gmap_iframe w-full h-[18rem]"
                                        frameBorder={0}
                                        scrolling="no"
                                        marginHeight={0}
                                        marginWidth={0}
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2773.4993658704493!2d-66.64181458457564!3d45.96128477910991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ca4195fdd4d9b57%3A0x6303ebfe1499e9d4!2sThe%20Talent%20Games!5e0!3m2!1sen!2s!4v1673942094493!5m2!1sen!2s"
                                    />



                                </div>

                            </div>

                            <div className="pinLocations flex justify-between mt-2">

                                <div className="pin1 flex items-center">
                                    <HiLocationMarker className='text-[1.9rem] text-[#FFD700]' />
                                    <p className="ml-0 font-semibold xl:text-[22px] mr-3 text-[3B4345]">Canada</p>
                                </div>
                                <div className="pin1 flex items-center">
                                    <HiLocationMarker className='text-[1.9rem] text-[#FFD700]' />
                                    <p className="ml-0 font-semibold xl:text-[22px] mr-3 text-[3B4345]">Pakistan</p>
                                </div>
                                <div className="pin1 flex items-center">
                                    <HiLocationMarker className='text-[1.9rem] text-[#FFD700]' />

                                    <p className="ml-0 font-semibold xl:text-[22px] text-[3B4345]">Singapore</p>
                                </div>
                            </div>

                        </div>

                        {/* map end */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactForm